import { ehEvento } from "@/constants/types/tipoTotem";

// Modalidade de repasse dos totens de evento: o parceiro contrata um pacote de
// fotos (ex.: 600 impressões por R$ 200) e o totem entrega sem cobrar do
// cliente final. No fim do dia a PhotoNow confere quantas fotos saíram e cobra
// o que passou do contratado — então cada impressão precisa virar uma venda no
// relatório, mesmo sem ninguém ter encostado o cartão.
export const ORIGEM_PAGAMENTO_EVENTO = "EVENTO";

// Editor e roteamento consultam a mesma flag de cobrança do Gestão.
// EVENTO permite desligamento sem prazo na API, mas seu tipo não desliga
// pagamento sozinho: religar pelo Gestão precisa voltar a pedir pagamento.
export function pulaEtapaPagamento(totem) {
  if (!totem) return false;
  return totem.config?.pular_etapa_pagamento === true;
}

// Verdadeiro quando a foto foi entregue sem cobrar mas a venda ainda conta no
// relatório. Vale para o totem de evento e só para ele: no totem comum com a
// cobrança desligada temporariamente não há pacote contratado para apurar, e
// marcar a compra como paga inflaria o faturamento do dia.
export function contabilizaVendaSemCobranca(totem) {
  return !!totem && ehEvento(totem.tipoTotem);
}
